// extracted by mini-css-extract-plugin
module.exports = {"input-add-form":"style_input-add-form__2NQZj","wrapper":"style_wrapper__3r9_K"};